import {DefaultParams, TGIdNameData} from "./general";
import {IhioData} from "./prescription";
import {TPatientFields} from "./patient";
import {PatientAdmissionType} from "./admission";

export type IhioPrescriptionAdmissionType = {
    nationalCode: string;
    trackingCode: string;
}

export const ihioPrescriptionAdmissionTypeInitialValues: IhioPrescriptionAdmissionType = {
    nationalCode: '',
    trackingCode: '',
}


export type IhioWrittenPrescriptionDeliveredItemsType = {
    delivery?: string;
    prescriber?: string;
    name?: string;
    fullName?: string;
    type?: TGIdNameData;
    itemCount?: number;
    patientPayment?: number;
    amount?: number;
    deliverDate?: number;
    description?: number;
}

export type IhioDeliverCheckCodeResponseType = IhioData & {
    priceInfo?: {
        tariffInfo?: {
            basePrice?: number;
            maxCoveredCount?: number;
            ihioBasePrice?: number;
            yaranehPart?: number;
            orgShare?: number;
            sisadDahPart?: number;
            serviceNN?: string;
            hasHash?: boolean;
            ownershipType?: string;
            ownership?: number;
            zaribKFani?: string;
            zaribKHerfeyie?: string;
            zaribKBihooshi?: string;
            kherfeyie?: number;
            kbihooshi?: number;
            kihioherfeyie?: number;
            kihiofani?: number;
            kihiobihooshi?: number;
            kfani?: number;
        };
        calculated?: {
            total?: number;
            orgAmount?: number;
            yaranehPart?: number;
            sisadDahPart?: number;
            insuredAmount?: number;
            lastPrice?: number;
            kfaniOrgAmount?: number;
            kbihooshiOrgAmount?: number;
            kHerfeyieOrgAmount?: number;
        };
        resultCode?: number;
        resultMessage?: string;
        maxCoveredCount?: number;
    }
}

export type IhioWrittenPrescriptionItemType = IhioDeliverCheckCodeResponseType & {
    UUID?: string;
    irc?: string;
    name?: string;
    fullName?: string;
    type?: TGIdNameData;
    shape?: TGIdNameData;
    itemCount?: number;
    itemsToBeDelivered?: number;
    numberOfPeriod?: number;
    bulkId?: number;
    description?: string;
    status?: TGIdNameData;
    activeDate?: string;
    deliveredItems?: IhioWrittenPrescriptionDeliveredItemsType[]
    countOfReference?: number;
    ihioBasePrice?: number;
}

export type IhioWrittenPrescriptionInfoType = {
    patient?: PatientAdmissionType & { patient: TPatientFields };
    creationDate?: string;
    providerName?: string;
    providerSpecialty?: string;
    irimcCode?: string;
    partnerName?: string;
    samadCode?: string;
    type?: TGIdNameData;
    items?: IhioWrittenPrescriptionItemType[];
}

export type PrescriptionFillingInfoLocationState = {
    prescriptionAdmissionData: IhioPrescriptionAdmissionType;
    writtenPrescriptionData: IhioWrittenPrescriptionInfoType;
}

export type IhioDeliverCheckCodeRequestType = {
    prescriptionTrackingCode?: string;
    patientNationalCode: string;
    irc: string;
    itemCount: number;
    description?: string;
    activeDate?: string;
    checkCodes: string[];
}

export type IhioSendPrescriptionFillingRequestType = {
    prescriptionTrackingCode?: string;
    patientNationalCode: string;
    checkCodes: string[];
}

export type IhioSendPrescriptionFillingResponseType = {
    messages: {
        infoMessage: string[];
        snackMessage: {
            type: string;
            text: string;
        }[]
    }
    checkCode: string;
    sequenceNumber: number;
}


export type  IhioGetFilledPrescriptionPrintRequest = IhioPrescriptionAdmissionType & {
    checkCode: string;
}


export type FilledPrescriptionDeliverListParams = DefaultParams & {
    nationalCode?: string;
    status?: string;
}

export type FilledPrescriptionDeliverListType = {
    age?: number;
    deliveredDate?: string;
    gender?: TGIdNameData;
    firstName?: string;
    lastName?: string;
    nationalNumber?: string;
    picture?: string;
    productName?: string;
    status?: TGIdNameData;
    trackingCode?: string;
    rowNum?: number;
    prescriptionType?: TGIdNameData;
    sequenceNumber?: number;
    checkCode?: string;
    relationType?: TGIdNameData;
    validTo?: string;
    dto?: string;
}


export type DeliveredPrescriptionDeliveredItem = {
    name?: string;
    fullName?: string;
    itemCount?: number;
    itemCountDelivered?: number;
    patientPayment?: number;
    amount?: number;
    deliveredDate?: string;
    description?: string;
    shape?: TGIdNameData;
    consumption?: string;
    consumptionInstruction?: string;
    bulkId?: number;
    consumptionSNOMEDCode?: string;
}

export type GetDeliveredPrescriptionResponseType = {
    visitSimultaneous?: boolean;
    orderPartnerInfo?: {
        partnerName?: string;
        partnerPhone?: string;
        contractPartyName?: string;
        noMedicalSystem?: number;
        licenseName?: string;
    };
    orderedDate?: string;
    deliveredDate?: string;
    samadCode?: string;
    type?: TGIdNameData;
    totalAmount?: number;
    totalPatientPayment?: number;
    deliveredItems?: DeliveredPrescriptionDeliveredItem[];
    deliveredWithNoRefItems?: DeliveredPrescriptionDeliveredItem[];
}


export type HistoryPrescriptionOrderListType = {
    age?: number;
    creationDate?: string;
    gender?: TGIdNameData;
    firstName?: string;
    lastName?: string;
    nationalNumber?: string;
    picture?: string;
    productName?: string;
    samadCode?: string;
    status?: TGIdNameData;
    partnerName?: string;
    trackingCode?: string;
    referenceTrackingCode?: string;
}


export type PrescriptionReferralListType = {
    citizenItemId?: string;
    memberNN?: string;
    memberFulName?: string;
    trackingCode?: string;
    serviceName?: string;
    creationDate?: string;
    productName?: string;
    samadCode?: string;
    referDelivered?: string;
}

export type PrescriptionReferralDetailResponseType = {
    samadCode?: string;
    creationDate?: string;
    partnerName?: string;
    contractpartyName?: string;
    trackingCode?: string;
    referralFeedback?: string;
}


export type PrescriptionReferralListParams = DefaultParams & {
    nationalCode?: string;
    feedBack?: boolean;
}
